import {
  afterNextRender,
  Directive,
  ElementRef,
  input,
  model,
  output,
} from '@angular/core';
import Swiper from 'swiper';
import { Autoplay, Grid, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[swiper]',
})
export class SwiperDirective {
  option = input<SwiperOptions>();
  activeIndex = output<number>();
  init = output<Swiper>();

  swiperRef = model<Swiper>();

  constructor(private el: ElementRef<HTMLElement>) {
    afterNextRender(() => {
      if (!this.el.nativeElement) return;
      this.swiperRef.set(
        new Swiper(this.el.nativeElement!, {
          ...this.option(),
          modules: [Autoplay, Grid, Pagination],
          on: {
            slideChange: () => {
              if (!this.swiperRef()) return;
              this.activeIndex.emit(this.swiperRef()?.activeIndex || 0);
            },
          },
        })
      );
      this.init.emit(this.swiperRef()!);
    });
  }

  next(): void {
    this.swiperRef()?.slideNext();
  }

  prev(): void {
    this.swiperRef()?.slidePrev();
  }
}
